export const formatBalance = (value) => {
    if (value == null || isNaN(value) || value <= 0) {
        return "0";
    }

    const parts = value.toString().split('.');
    const integerPart = parts[0];
    const decimalPart = parts[1] ? parts[1].slice(0, 5) : '';
    const amount = `${integerPart}${decimalPart ? '.' + decimalPart : ''}`;

    return amount;
};